import { useRef, useState } from 'react';
export const useToggleMenu = props => {
  // The Menu's onDismiss is fired prior to Button's onClick, which cause Menu will be open always.
  // To avoid it, use this flag to control if the onDimiss should be fired.
  // This flag is FALSE initially and turn to TRUE in Button's onMouseDown and
  // reset to FALSE in Menu's onDismiss and Button's onClick events
  const refSuppressDimissEvent = useRef(false);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  function handleDismiss() {
    if (refSuppressDimissEvent.current) {
      refSuppressDimissEvent.current = false;
      return;
    }
    setMenuIsOpen(false);
    props.onDismiss?.();
  }
  function handleMouseDown(e) {
    if (props.disabled) return;
    if (e.button === 0) {
      refSuppressDimissEvent.current = true;
    }
  }
  function handlePress() {
    if (props.disabled) return;
    const toOpenMenu = !menuIsOpen;
    setMenuIsOpen(toOpenMenu);
    toOpenMenu ? props.onOpen?.() : props.onDismiss?.();
    refSuppressDimissEvent.current = false;
  }
  return {
    handleDismiss,
    handleMouseDown,
    handlePress,
    setMenuIsOpen,
    menuIsOpen
  };
};
//# sourceMappingURL=useToggleMenu.js.map